export class CString {
    static take(s: string, i: number): string {
        return s.substring(0, (s.length >= i ? i : s.length));
    }
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/classes/c-string.ts